import React, { useState } from "react";
import {
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Typography,
  Box,
  Chip,
  Button,
  Divider,
} from "@mui/material";
import PaymentInfo from "../payment-info/PaymentInfo";
import OrderDetailsDrawer from "../order-details-drawer/OrderDetailsDrawer";

const statusColors = {
  Ready: { label: "Ready", color: "success" },
  "In Progress": { label: "In Progress", color: "warning" },
  Completed: { label: "Completed", color: "default" },
};

export default function OrderList({ orders }) {
  const [isSettleDialogOpen, setIsSettleDialogOpen] = useState(false);
  const [isOrderDetailsDrawerOpen, setIsOrderDetailsDrawerOpen] =
    useState(false);

  const handleDialogCancel = () => {
    setIsSettleDialogOpen(false);
  };

  const handleSettleDialog = () => {
    setIsSettleDialogOpen(true);
  };

  const handleCloseOrderDetailsDrawer = () => {
    setIsOrderDetailsDrawerOpen(false);
  };

  const handleOrderDetailsDrawer = () => {
    setIsOrderDetailsDrawerOpen(true);
  };
  return (
    <>
      <List
        sx={{
          width: "100%",
          bgcolor: "background.paper",
          borderRadius: "10px",
        }}
      >
        {orders.map((order) => {
          const totalQty = order.items.reduce((sum, i) => sum + i.qty, 0);

          return (
            <React.Fragment key={order.id}>
              <ListItem
                alignItems="flex-start"
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                {/* Left side (Avatar + Name + Order info) */}
                <Box display="flex" alignItems="center" gap={1.5}>
                  <ListItemAvatar>
                    <Avatar variant="rounded" sx={{ bgcolor: "grey.800" }}>
                      {order.table}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                      <Box display="flex" alignItems="center" gap={1}>
                        <Typography variant="subtitle1" fontWeight={600}>
                          #{order.id} / {order.type}
                        </Typography>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "8px",
                          }}
                        >
                          <Typography
                            variant="caption"
                            color="text.secondary"
                            style={{
                              background: "rgb(0, 171, 85)",
                              color: "#fff",
                              fontSize: "12px",
                              borderRadius: "10px",
                              padding: "2px 5px",
                              fontWeight: 600,
                            }}
                          >
                            10 min
                          </Typography>
                          <Chip
                            label={statusColors[order.status]?.label}
                            color={statusColors[order.status]?.color}
                            variant="outlined"
                            size="small"
                            sx={{ fontWeight: 500 }}
                          />
                        </Box>
                        {/* <Chip
                        label={statusColors[order.status]?.label}
                        color={statusColors[order.status]?.color}
                        size="small"
                        variant="outlined"
                      /> */}
                      </Box>
                    }
                    secondary={
                      <>
                        <Box display="flex" alignItems="center" gap="10px">
                          <Typography variant="body2" color="text.secondary">
                            <Chip label="Rooftop" size="small" />
                          </Typography>

                          <Typography variant="caption" color="text.secondary">
                            • Ready to serve
                          </Typography>
                        </Box>
                        <Typography variant="caption" color="text.secondary">
                          {order.date} • {order.time}
                        </Typography>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{ fontSize: "12px", paddingBottom: "4px" }}
                        >
                          Cust Name: {order.name}
                        </Typography>
                      </>
                    }
                  />
                </Box>

                {/* Right side (Qty + Total + Buttons) */}
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="flex-end"
                  gap={1}
                >
                  <Typography variant="body2" color="text.secondary">
                    Qty: {totalQty} &nbsp; | &nbsp; Total Amount:{" "}
                    <b>${order.total.toFixed(2)}</b>
                  </Typography>

                  <Box display="flex" gap={1}>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={handleOrderDetailsDrawer}
                    >
                      See Details
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      color="warning"
                      onClick={handleSettleDialog}
                    >
                      Pay Bills
                    </Button>
                  </Box>
                </Box>
              </ListItem>
              <Divider component="li" />
            </React.Fragment>
          );
        })}
      </List>

      {isSettleDialogOpen && (
        <PaymentInfo
          isSettleDialogOpen={isSettleDialogOpen}
          onDialogCancel={handleDialogCancel}
        />
      )}
      <OrderDetailsDrawer
        isOpen={isOrderDetailsDrawerOpen}
        closeOrderDetailsDrawer={handleCloseOrderDetailsDrawer}
      />
    </>
  );
}
